export const GET_WASTE_ROLLS = 'GET_WASTE_ROLLS';
export const GET_WASTE_ROLLS_SUCCESS = 'GET_WASTE_ROLLS_SUCCESS';
export const GET_WASTE_ROLLS_FAIL = 'GET_WASTE_ROLLS_FAIL';
